import React from 'react';
import './PrivacyPolicy.css';
import SEO from '../components/SEO';
import { useTranslation } from 'react-i18next';

const PrivacyPolicy = () => {
  const { t } = useTranslation('privacy');
  const dataItems = t('sections.data.items', { returnObjects: true }) || [];

  return (
    <div className="privacy-container">
      <SEO
        title={t('seo.title')}
        description={t('seo.description')}
        keywords="politique de confidentialité, privacy policy, RGPD, GDPR, MKD Studio"
      />

      <section className="privacy-hero">
        <div className="container">
          <h1>{t('hero.title')}</h1>
          <p className="privacy-updated">{t('hero.updated')}</p>
        </div>
      </section>

      <section className="privacy-content">
        <div className="container">
          <div className="privacy-intro">
            <p>{t('intro')}</p>
          </div>

          <div className="privacy-card">
            <h2>{t('sections.who.title')}</h2>
            <p>{t('sections.who.body')}</p>
          </div>

          <div className="privacy-card">
            <h2>{t('sections.data.title')}</h2>
            <ul>
              {dataItems.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </div>

          <div className="privacy-card">
            <h2>{t('sections.why.title')}</h2>
            <p>{t('sections.why.body')}</p>
          </div>

          <div className="privacy-card">
            <h2>{t('sections.minors.title')}</h2>
            <p>{t('sections.minors.body')}</p>
          </div>

          <div className="privacy-card">
            <h2>{t('sections.retention.title')}</h2>
            <p>{t('sections.retention.body')}</p>
          </div>

          <div className="privacy-card">
            <h2>{t('sections.security.title')}</h2>
            <p>{t('sections.security.body')}</p>
          </div>

          <div className="privacy-card">
            <h2>{t('sections.rights.title')}</h2>
            <p>{t('sections.rights.body')}</p>
          </div>

          <div className="privacy-card">
            <h2>{t('sections.contact.title')}</h2>
            <p>
              {t('sections.contact.body1')}{' '}
              <a href={`mailto:${t('sections.contact.email')}`}>{t('sections.contact.email')}</a>
            </p>
            <p>{t('sections.contact.body2')}</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
